import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Container } from "@mui/material";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => {
      clearInterval(countdown);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          backgroundColor: "#1e1e1e",
          px: 2,
          borderRadius: 2,
        }}
      >
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          404 - Page Not Found
        </Typography>
        <Typography variant="h6">
          Redirecting to Home Page in{" "}
          <Typography component="span" fontWeight="bold" display="inline">
            {seconds}
          </Typography>{" "}
          second{seconds !== 1 && "s"}...
        </Typography>
      </Box>
    </Container>
  );
}
